import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsDateString,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { AgentProfileId } from '../../../../types';
import {
  AgentCardAddressDto,
  AgentCardCciDto,
  AgentCardInsurerDto,
  AgentCardLeaderDto,
  AgentCardMentionsDto,
} from '../agent-card/agent-card.dto';
import {
  AgentActivityDto,
  AgentInterventionDto,
  AgentType,
  AgentUserPublicDto,
  AgentWorkDto,
} from './agent-profile.dto';

export class AgentCardPublicDto {
  @IsString()
  @IsNotEmpty()
  number!: string;

  @IsString()
  @IsNotEmpty()
  companyName!: string;

  @IsString()
  @IsNotEmpty()
  siren!: string;

  @IsString()
  @IsNotEmpty()
  legalForm!: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardCciDto)
  cci?: AgentCardCciDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardAddressDto)
  address?: AgentCardAddressDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardLeaderDto)
  leader?: AgentCardLeaderDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardMentionsDto)
  mentions?: AgentCardMentionsDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => AgentCardInsurerDto)
  insurer?: AgentCardInsurerDto;

  @IsDateString()
  @IsNotEmpty()
  expiresAt!: string;

  @IsBoolean()
  @IsOptional()
  isActive?: boolean;
}

export class AgentCardsPublicDto {
  @ValidateNested()
  @Type(() => AgentCardPublicDto)
  @IsOptional()
  activeCard?: AgentCardPublicDto;
}

export class AgentProfilePublicDto {
  @IsString()
  @IsNotEmpty()
  _id!: AgentProfileId;

  @IsEnum(['titulaire', 'mandataire'])
  @IsNotEmpty()
  type!: AgentType;

  @ValidateNested()
  @Type(() => AgentUserPublicDto)
  @IsOptional()
  user?: AgentUserPublicDto;

  @ValidateNested()
  @Type(() => AgentCardsPublicDto)
  @IsOptional()
  cards?: AgentCardsPublicDto;

  @ValidateNested()
  @Type(() => AgentInterventionDto)
  @IsOptional()
  intervention?: AgentInterventionDto;

  @ValidateNested()
  @Type(() => AgentActivityDto)
  @IsOptional()
  activity?: AgentActivityDto;

  @ValidateNested()
  @Type(() => AgentWorkDto)
  @IsOptional()
  work?: AgentWorkDto;

  @IsBoolean()
  @IsOptional()
  isVacationMode?: boolean;

  @IsDate()
  @IsOptional()
  createdAt?: Date;

  @IsDate()
  @IsOptional()
  updatedAt?: Date;
}
